<template>
    <div id="goal-setting">
      <div v-if="currentTab === 'objective'">
        <h2>Objective</h2>
        <input v-model="objective.name" placeholder="Name" />
        <textarea v-model="objective.description" placeholder="Description"></textarea>
        <button @click="submit">Create Objective</button>
      </div>
  
      <div v-if="currentTab === 'financialGoal'">
        <h2>Financial Goal</h2>
        <input v-model="financialGoal.name" placeholder="Name" />
        <select v-model="financialGoal.goal_type">
          <option value="financial">Financial</option>
          <option value="non_financial">Non-Financial</option>
        </select>
        <input v-model="financialGoal.amount" placeholder="Amount" type="number" />
        <input v-model="financialGoal.metric" placeholder="Metric" />
        <input type="checkbox" v-model="financialGoal.is_achievable" /> Achievable
        <textarea v-model="financialGoal.relevance" placeholder="Relevance"></textarea>
        <input v-model="financialGoal.due_date" placeholder="Due Date (yyyy-mm-dd)" type="date" />
        <button @click="submit">Create Financial Goal</button>
      </div>
  
      <div v-if="currentTab === 'goalMilestone'">
        <h2>Goal Milestone</h2>
        <textarea v-model="goalMilestone.description" placeholder="Description"></textarea>
        <input v-model="goalMilestone.amount" placeholder="Amount" type="number" />
        <input v-model="goalMilestone.date_achieved" placeholder="Date Achieved (yyyy-mm-dd)" type="date" />
        <button @click="submit">Create Milestone</button>
      </div>
    </div>
  </template>
  
  <script>
  import { ref } from "vue";
  import axios from "axios";
  
  export default {
    setup() {
      const objective = ref({
        name: "",
        description: "",
        user: 1  // Add the user field here
      });
  
      const financialGoal = ref({
        name: "",
        goal_type: "financial",
        amount: null,
        metric: "",
        is_achievable: true,
        relevance: "",
        due_date: "",
      });
  
      const goalMilestone = ref({
        description: "",
        amount: null,
        date_achieved: "",
      });
  
      const createObjective = async () => {
        await axios.post("https://farahk.pythonanywhere.com/goaltracker/api/objectives/", objective.value);
      };
  
      const createFinancialGoal = async () => {
        await axios.post("https://farahk.pythonanywhere.com/goaltracker/api/financial_goals/", financialGoal.value);
      };
  
      const createGoalMilestone = async () => {
        await axios.post("https://farahk.pythonanywhere.com/goaltracker/api/goal_milestones/", goalMilestone.value);
      };
  
      return {
        objective,
        financialGoal,
        goalMilestone,
        createObjective,
        createFinancialGoal,
        createGoalMilestone,
      };
    },
  };
</script>

  
  <style scoped>
  #goal-setting {
    border-radius: 8px;
    background-color: #fff;
    padding: 20px;
    margin: 20px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }
  input, textarea, select, button {
    display: block;
    margin-top: 10px;
  }
  button {
    background-color: black;
    color: white;
    padding: 10px;
    border-radius: 8px;
    cursor: pointer;
  }
  button:hover {
    background-color: orange;
  }
  </style>
  